import { render, staticRenderFns } from "./app-token-form.vue?vue&type=template&id=cb47fb68"
import script from "./app-token-form.vue?vue&type=script&lang=js"
export * from "./app-token-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports